import { useState } from "react";

export const useFileUploader = upload => {
  const [progress, setProgress] = useState(0);
  const [total, setTotal] = useState(0);

  const uploadFileToBackend = file => new Promise(resolve => {
    const reader = new FileReader();

    reader.onload = () => {
      const base64 = reader.result.split(",")[1];

      upload(file, base64).then(resolve);
    };

    reader.readAsDataURL(file);
  });

  const uploadFiles = async (files, maxConcurrent = 5) => {
    setTotal(files.length);
    setProgress(0);

    const queue = [...files];

    let completedCount = 0;

    const worker = async () => {
      while (queue.length > 0) {
        const file = queue.shift();

        try {
          await uploadFileToBackend(file);
        } catch (error) {
          console.error(`Failed to upload ${file.name}:`, error);
        } finally {
          // Increment the counter safely
          completedCount++;
          setProgress(completedCount);
        }
      }
    };

    const workers = Array(Math.min(maxConcurrent, files.length))
      .fill(null)
      .map(() => worker());

    await Promise.all(workers);
  };

  return { uploadFiles, progress, total };
};
